/**
 * @generated SignedSource<<1c6960ad2a7fcd32e91a34c371071f6c>>
 * @relayHash a62833dfd2661ff1b5ca07e6a551b824
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f0d4ed5503c6f67b5a7266ea07fcc9d673749ecd294218cabda51d8920bbb1e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraForgeEnvironmentType = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "%future added value";
export type JiraVisibilityControlMechanism = "AppAccessRules" | "DisplayConditions" | "UnlicensedAccess" | "%future added value";
export type JiraExtensionRenderingContextInput = {
  issueKey?: string | null | undefined;
  issueTypeId?: string | null | undefined;
  portalId?: string | null | undefined;
  projectKey?: string | null | undefined;
  requestTypeId?: string | null | undefined;
};
export type useExtensionsQuery$variables = {
  cloudId: string;
  context: JiraExtensionRenderingContextInput;
  includeHidden: boolean;
  types: ReadonlyArray<string>;
};
export type useExtensionsQuery$data = {
  readonly jira: {
    readonly forge: {
      readonly extensions: ReadonlyArray<{
        readonly appVersion: string;
        readonly consentUrl: string | null | undefined;
        readonly egress: ReadonlyArray<{
          readonly addresses: ReadonlyArray<string> | null | undefined;
          readonly category: string | null | undefined;
          readonly inScopeEUD: boolean | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined>;
        readonly environmentId: string;
        readonly environmentKey: string;
        readonly environmentType: JiraForgeEnvironmentType;
        readonly hiddenBy: JiraVisibilityControlMechanism | null | undefined;
        readonly id: string;
        readonly installationConfig: ReadonlyArray<{
          readonly key: string;
          readonly value: boolean;
        }> | null | undefined;
        readonly installationId: string;
        readonly license: {
          readonly active: boolean;
          readonly billingPeriod: string | null | undefined;
          readonly capabilitySet: string | null | undefined;
          readonly ccpEntitlementId: string | null | undefined;
          readonly ccpEntitlementSlug: string | null | undefined;
          readonly isEvaluation: boolean | null | undefined;
          readonly subscriptionEndDate: AGG$DateTime | null | undefined;
          readonly supportEntitlementNumber: string | null | undefined;
          readonly trialEndDate: AGG$DateTime | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly moduleId: string | null | undefined;
        readonly properties: AGG$JSON;
        readonly type: string;
        readonly userAccess: {
          readonly enabled: boolean;
          readonly hasAccess: boolean;
        } | null | undefined;
      }> | null | undefined;
    };
  } | null | undefined;
};
export type useExtensionsQuery = {
  response: useExtensionsQuery$data;
  variables: useExtensionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeHidden"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "types"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraForgeQuery",
        "kind": "LinkedField",
        "name": "forge",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "context",
                "variableName": "context"
              },
              {
                "kind": "Variable",
                "name": "includeHidden",
                "variableName": "includeHidden"
              },
              {
                "kind": "Variable",
                "name": "types",
                "variableName": "types"
              }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hiddenBy"
              },
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "moduleId"
              },
              {
                "kind": "ScalarField",
                "name": "environmentId"
              },
              {
                "kind": "ScalarField",
                "name": "environmentKey"
              },
              {
                "kind": "ScalarField",
                "name": "environmentType"
              },
              {
                "kind": "ScalarField",
                "name": "installationId"
              },
              {
                "kind": "ScalarField",
                "name": "appVersion"
              },
              {
                "kind": "ScalarField",
                "name": "consentUrl"
              },
              {
                "kind": "ScalarField",
                "name": "properties"
              },
              {
                "concreteType": "JiraUserAppAccess",
                "kind": "LinkedField",
                "name": "userAccess",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasAccess"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              },
              {
                "concreteType": "JiraForgeAppEgressDeclaration",
                "kind": "LinkedField",
                "name": "egress",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "addresses"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "inScopeEUD"
                  }
                ]
              },
              {
                "concreteType": "JiraForgeInstallationConfigExtension",
                "kind": "LinkedField",
                "name": "installationConfig",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              {
                "concreteType": "JiraForgeExtensionLicense",
                "kind": "LinkedField",
                "name": "license",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "active"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "supportEntitlementNumber"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "subscriptionEndDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEvaluation"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "billingPeriod"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ccpEntitlementId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ccpEntitlementSlug"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "capabilitySet"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useExtensionsQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useExtensionsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "8f0d4ed5503c6f67b5a7266ea07fcc9d673749ecd294218cabda51d8920bbb1e",
    "metadata": {},
    "name": "useExtensionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ca72edb566d5f0ae17dcb8d6cee09569";

export default node;
